<template>
    <div id="futurocoin_payout_component"
         class="futurocoin-payout-component">
        <div class="payout-header"
             @click="toggleList()">
            <p>
                Show payout schedule
                <div class="triangle triangle--bottom" v-if="!payoutsOpen"></div>
                <div class="triangle triangle--top" v-if="payoutsOpen"></div>
            </p>
        </div>
        <ul class="payout-list"
            v-show="payoutsOpen"
            v-if="payouts.length > 0">
            <li v-for="(item, index) in payouts" :key="index">
                <p>
                    <span class="payout-list--date">to {{ item.date }}</span>
                    <span class="payout-list--spacer">up to</span>
                    <span class="payout-list--label">{{ money.format(item.to_withdraw.amount, 'fto') }} {{ item.to_withdraw.currency }} - {{ item.percent }}% of yours FuturoCoins</span>
                </p>
            </li>
        </ul>
        <div class="data-loader__block"
             v-if="payouts.length == 0"></div>
    </div>
</template>

<script>
    export default {
        dependencies: ['money'],
        data () {
            return {
                payoutsOpen: false,
            }
        },
        computed: {
            payouts () {
                return this.$store.getters.futurocoinWithdraw.length > 0 ? this.$store.getters.futurocoinWithdraw : []
            }
        },
        methods: {
            toggleList () {
                this.payoutsOpen = !this.payoutsOpen
            }
        }
    }
</script>

<style lang="scss">
    .futurocoin-payout-component{
        margin: 15px 0 30px;
    }

    .payout-header{
        margin-bottom: 30px;
        cursor: pointer;

        p{
            display: inline-block;
        }

        .triangle{
            margin-left: 20px;
        }
    }

    .payout-list{
        li{
            margin-bottom: 6px;
        }
        &--spacer {
            margin-right: 23px;
        }
    }

    .payout-list--date{
        width: 15%;
        display: inline-block;
    }

    @media(max-width: 991px){
        .payout-list--date{
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/futurocoin/FuturocoinPayout.vue